module.exports = __webpack_public_path__ + "static/media/solo21.75ea576f.JPG";